import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDkXTHHhDa_nuvdQBWHZJz67xUOlB0k17o",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "bizmarketplace-f6aaf.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "bizmarketplace-f6aaf",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "bizmarketplace-f6aaf.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1081939186345",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:1081939186345:web:8c9832ff6515d2f884cfb8",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-DNT1VDY6G8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app; 